export default theme => ({
  title: {
    marginTop: "16px",
    marginBottom: "8px",
  },
  instructions: {
    marginBottom: "16px",
    display: "block",
  },
  sectionTitle: {
    marginTop: "8px",
    marginBottom: "16px",
  },
  sectionInstructions: {
    marginBottom: "8px",
    display: "block",
  },
  videoList: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  videoItem: {
    padding: "12px",
    backgroundColor: "#f5f5f5",
    borderRadius: "4px",
    cursor: "move",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "8px",
  },
  itemNumber: {
    fontWeight: "bold",
    minWidth: "30px",
  },
  itemLabel: {
    flex: 1,
  },
  audioList: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  audioItem: {
    padding: "12px",
    backgroundColor: "#f5f5f5",
    borderRadius: "4px",
    cursor: "move",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "8px",
  },
});
